import { gql } from "@urql/core";

export const CODEABLE_CONCEPT_FRAGMENT = gql`
  fragment CodeableConceptFields on CodeableConcept {
    coding {
      code
      display
      system
    }
    text
  }
`;

export const DOSAGE_FRAGMENT = gql`
  fragment DosageFields on Dosage {
    asNeededBoolean
    doseAndRate {
      doseQuantity {
        unit
        value
      }
      doseRange {
        high {
          unit
          value
        }
        low {
          unit
          value
        }
      }
    }
    extension {
      url
      valueDosage {
        doseAndRate {
          doseQuantity {
            unit
            value
          }
          doseRange {
            high {
              unit
              value
            }
            low {
              unit
              value
            }
          }
        }
        timing {
          repeat {
            frequency
            period
            periodUnit
            when
          }
        }
      }
    }
    route {
      text
    }
    text
    timing {
      repeat {
        frequency
        period
        periodUnit
        when
      }
    }
  }
`;

export const QUANTITY_FRAGMENT = gql`
  fragment QuantityFields on Quantity {
    value
    comparator
    unit
    system
    code
  }
`;

export const RATIO_FRAGMENT = gql`
  fragment RatioFields on Ratio {
    numerator {
      ...QuantityFields
    }
    denominator {
      ...QuantityFields
    }
  }
  ${QUANTITY_FRAGMENT}
`;
